import { render, staticRenderFns } from "./RoleManage.vue?vue&type=template&id=27615966&"
import script from "./RoleManage.vue?vue&type=script&lang=js&"
export * from "./RoleManage.vue?vue&type=script&lang=js&"
import style0 from "./RoleManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports